import Fallback from "app/components/Fallback";
import React from "react";

const Books = React.lazy(
  () => import("app/modules/FirmManagement/books/Books"),
);

const Uniform = React.lazy(
  () => import("app/modules/FirmManagement/uniform/Uniform"),
);

const Firm = React.lazy(() => import("app/modules/FirmManagement/firms/Firms"));
const FirmInvoice = React.lazy(
  () => import("app/modules/FirmManagement/firmInvoice/FirmInvoice"),
);

export const BooksPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Books {...props} />
  </React.Suspense>
);

export const UniformPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Uniform {...props} />
  </React.Suspense>
);

export const FirmPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Firm {...props} />
  </React.Suspense>
);

export const FirmInvoicePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <FirmInvoice {...props} />
  </React.Suspense>
);
